import { useEffect, lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Loader from "./reuseable/Loader";
import "./App.css";
import pb from "./utils/pocketbase";
import Layout from "./layout/Layout"; // Import your Layout component



function App() {


  const Dashboard = lazy(() => import("./pages/Dashboard"));
  const Accounts = lazy(() => import("./pages/Accounts"));
  const Login = lazy(() => import("./pages/Login"));
  const Transaction = lazy(() => import("./pages/Transaction"));
  const DualTransaction = lazy(() => import("./pages/DualTransaction"));
  const Inventory = lazy(() => import("./pages/Inventory"));
  const TransactionReport = lazy(() => import("./pages/TransactionReport"));
  const SalesReport = lazy(() => import("./pages/SalesReport"));
  const CreditReport = lazy(() => import("./pages/CreditReport"));
  const Ledger = lazy(() => import("./pages/Ledger"));
  const StockReport = lazy(() => import("./pages/StockReport"));
  const FoodOrder = lazy(() => import("./pages/FoodOrder"));
  const Products = lazy(() => import("./pages/Products"));
  const FoodDashboard = lazy(() => import("./pages/FoodDashboard"));
  const OrderItems = lazy(() => import("./pages/OrderItems"));
  const Dateset = lazy(() => import("./pages/Dateset"));
  const Orders = lazy(() => import("./pages/Orders"));
  const Ledgernew = lazy(() => import("./pages/Ledgernew"));
  const ProjectOverview = lazy(() => import("./pages/ProjectOverview"));
  const Tender = lazy(() => import("./pages/Tender"));
  const Project = lazy(() => import("./pages/Project"));
  const TenderOverview = lazy(() => import("./pages/TenderOverview"));
  const Signup = lazy(() => import("./pages/Signup"));
  const Expense = lazy(() => import("./pages/Expense"));
  const ManageUsers = lazy(() => import("./pages/ManageUsers"));

  return (
    <>
      <Suspense fallback={<Loader />}>
        <BrowserRouter>
          <Routes>
            {/* Login without Layout */}
            <Route path="/" element={<Login />} />
            <Route path="/signup" element={<Signup />} />

            {/* Routes with Layout */}
            <Route
              path="/dashboard"
              element={
                <Layout>
                  <Dashboard />
                </Layout>
              }
            /> 
             <Route
              path="/manuser"
              element={
                <Layout>
                  <ManageUsers />
                </Layout>
              }
            /> 
             <Route
              path="/tenderoverview"
              element={
                <Layout>
                  <TenderOverview />
                </Layout>
              }
            /> 
              <Route
              path="/expense"
              element={
                <Layout>
                  <Expense />
                </Layout>
              }
            /> 
            
             <Route
              path="/project"
              element={
                <Layout>
                  <Project />
                </Layout>
              }
            /> 
               <Route
              path="/tender"
              element={
                <Layout>
                  <Tender />
                </Layout>
              }
            /> 
            <Route
            path="/ledgernew"
            element={
              <Layout>
                <Ledgernew />
              </Layout>
            }
          />
          <Route
            path="/projectdetails"
            element={
              <Layout>
                <ProjectOverview />
              </Layout>
            }
          />
              <Route
              path="/orders"
              element={
                <Layout>
                  <Orders />
                </Layout>
              }
            />
              <Route
              path="/dateset"
              element={
                <Layout>
                  <Dateset />
                </Layout>
              }
            />
              <Route
              path="/orders/:orderId"
              element={
                <Layout>
                  <OrderItems />
                </Layout>
              }
            />
            
            <Route
              path="/fooddashboard"
              element={
                <Layout>
                  <FoodDashboard />
                </Layout>
              }
            />
             <Route
              path="/products"
              element={
                <Layout>
                  <Products />
                </Layout>
              }
            />
            <Route
              path="/foodorder"
              element={
                <Layout>
                  <FoodOrder />
                </Layout>
              }
            />
            
             <Route
              path="/transactionreport"
              element={
                <Layout>
                  <TransactionReport />
                </Layout>
              }
            />
              <Route
              path="/stockreport"
              element={
                <Layout>
                  <StockReport />
                </Layout>
              }
            />
            <Route
              path="/creditreport"
              element={
                <Layout>
                  <CreditReport />
                </Layout>
              }
            />
            <Route
              path="/salesreport"
              element={
                <Layout>
                  <SalesReport />
                </Layout>
              }
            />
             <Route
              path="/ledger"
              element={
                <Layout>
                  <Ledger />
                </Layout>
              }
            />
            <Route
              path="/accounts"
              element={
                <Layout>
                  <Accounts />
                </Layout>
              }
            />
            <Route
              path="/transaction"
              element={
                <Layout>
                  <Transaction />
                </Layout>
              }
            />
            <Route
              path="/dualtransaction"
              element={
                <Layout>
                  <DualTransaction />
                </Layout>
              }
            />
            <Route
              path="/inventory"
              element={
                <Layout>
                  <Inventory />
                </Layout>
              }
            />
          </Routes>
        </BrowserRouter>
      </Suspense>
    </>
  );
}

export default App;
